import posthog from "posthog-js";

export function initPostHog() {
	const key = import.meta.env.VITE_POSTHOG_KEY;
	if (!key || window.location.hostname !== "clearvoid.ai") return;

	posthog.init(key, {
		// First-party proxy (apps/clearvoid/public/_worker.js → PostHog US
		// cloud). Ad blockers block us.i.posthog.com by domain list; the
		// same-origin path keeps capture working for the dev/X audience.
		api_host: "https://clearvoid.ai/ingest",
		ui_host: "https://us.posthog.com",
		autocapture: false,
		capture_pageview: false,
	});

	// First-touch attribution as super-properties: every event in the session
	// carries where the visitor came from (t.co / x.com = X traffic), so a
	// download or install click is attributable directly, without joining back
	// to the first pageview.
	const attribution: Record<string, string> = {};
	if (document.referrer) {
		attribution.landing_referrer = document.referrer;
		try {
			attribution.landing_referring_domain = new URL(
				document.referrer,
			).hostname;
		} catch {
			// unparseable referrer — keep the raw string only
		}
	}
	const params = new URLSearchParams(window.location.search);
	for (const param of ["utm_source", "utm_medium", "utm_campaign", "ref"]) {
		const value = params.get(param);
		if (value) attribution[param] = value;
	}
	if (Object.keys(attribution).length > 0) posthog.register(attribution);
}

export function identifyUser(
	userId: string,
	properties?: Record<string, unknown>,
) {
	posthog.identify(userId, properties);
}

export function trackEvent(
	event: string,
	properties?: Record<string, unknown>,
) {
	posthog.capture(event, properties);
}

export function trackPageView(url?: string) {
	posthog.capture("$pageview", url ? { $current_url: url } : undefined);
}

export function resetUser() {
	posthog.reset();
}
